import styled, { css } from 'styled-components'
import { Row } from '@sainsburys-tech/bolt'
import { createBorder, colorToLunaToken } from '../../../helpers/theming/utilities'
import { LinkWrapper } from '../../../helpers/StyledWrappers.styles'
import { themeContract } from './M014.theme.contract'

const lineHeight = '1.5rem'

const backgroundColor = (props) => {
  const defaultColor = props.theme.color.monochrome[themeContract[props.theme.channel].background.color]

  return props.backgroundColor === 'white' ? defaultColor : colorToLunaToken(props.backgroundColor, props.theme)
}

const WrapperCSS = css`
  height: 160px;
  display: flex;
  text-align: center;
  background-size: cover;
  text-decoration: none;
  overflow: hidden;
  position: relative;
  z-index: 1;

  ${(props) =>
    props.backgroundImageStyle &&
    css`
      background-image: ${props.backgroundImageStyle};
    `}

  ${(props) =>
    css`
      margin-bottom: ${props.theme.size.spacing.lg};
      background-color: ${backgroundColor(props)};

      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) {
        height: 250px;
        margin-bottom: 0;
      }
    `}

  &:last-of-type {
    margin-bottom: 0;
  }
`

const OuterWrapper = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  flex-flow: column wrap;
  width: 100%;

  ${(props) =>
    css`
      margin-bottom: ${props.theme.size.spacing.lg};
      border-radius: ${props.theme.size.border.radius.base};
    `}

  ${(props) =>
    themeContract[props.theme.channel].border.visible &&
    css`
      ${createBorder(props.theme.size.border.width.sm, props.theme.color.monochrome.light)}
    `}
`

const WrapperDiv = styled(Row)`
  ${WrapperCSS}
`

const WrapperLink = styled(Row)`
  ${WrapperCSS}
  ${LinkWrapper}
`

const GridWrapper = styled(Row)`
  flex: 1 1 0px;
`

const ImageWrapper = styled.div`
  flex: 7 7 0px;
  width: 65%;
  margin: 0 auto;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-origin: content-box;
  padding: 2px;

  ${(props) =>
    props.imageStyle &&
    css`
      background-image: ${props.imageStyle};
    `}

  ${(props) =>
    css`
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) {
        flex: 11 11 0px;
      }
    `}
`

const CopyWrapper = styled(Row)`
  justify-content: center;
  display: flex;
  align-items: center;
  flex: 8 8 0px;

  ${(props) =>
    css`
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) {
        display: block;
      }
    `}
`

const HeaderWrapperAlignmentCSS = css`
  text-align: center;
  align-items: center;
  justify-content: flex-start;
`

const HeaderWrapper = styled(Row)`
  padding: 0 5px;
  position: relative;
  width: 100%;
  text-align: left;
  align-items: flex-start;
  justify-content: center;

  ${(props) =>
    css`
      background-color: ${backgroundColor(props)};

      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) {
        ${HeaderWrapperAlignmentCSS}
        flex: 1 1 0px;
      }
    `}
`

const HeaderCopy = styled.h4`
  && {
    margin: 0;

    ${(props) =>
      props.theme.channel === 'habitat' &&
      css`
        line-height: ${lineHeight};
      `}
  }

  color: ${(props) => colorToLunaToken(props.textColor, props.theme)};

  ${(props) =>
    css`
      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) {
        width: 100%;
        ${props.theme.channel === 'habitat' &&
        css`
          line-height: ${lineHeight};
        `}
      }
    `}
`

const BodyCopy = styled.p`
  && {
    margin: 0;   
    
    ${(props) =>
      props.theme.channel === 'argos' &&
      css`
        line-height: unset;
      `}
      }
  }

  color: ${(props) => colorToLunaToken(props.textColor, props.theme)};
`

const SubHeading = styled(BodyCopy)`
  max-width: 100%;
  width: 100%;
`

const LegalCopy = styled(SubHeading)`
  overflow: hidden;
  max-height: 30px;
  font-size: ${(props) => props.theme.font.size.caption};
  background-color: ${(props) => backgroundColor(props)};

  ${(props) =>
    props.isBlock
      ? css`
          flex: 0 0 auto;
          opacity: 0;
          padding: 10px;
        `
      : css`
          position: absolute;
          bottom: 0;
          width: 100%;
          padding: 4px 10px;
          text-shadow: none;
          pointer-events: none;
          cursor: default;
          z-index: 1;

          a {
            pointer-events: auto;
          }

          p {
            margin: 0;
          }
        `}
`

export {
  OuterWrapper,
  WrapperDiv,
  WrapperLink,
  GridWrapper,
  ImageWrapper,
  CopyWrapper,
  HeaderWrapper,
  HeaderCopy,
  SubHeading,
  BodyCopy,
  LegalCopy
}
